import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActivatedRoute } from '@angular/router';
import { NG_ICON_DIRECTIVES } from '@ng-icons/core';

// export interface businessButtonConfig {
//   isButtonDisabled: boolean,
//   isValueChanged: boolean
// }
@Component({
  selector: 'app-nodata-found',
  standalone: true,
  imports: [CommonModule,

    NG_ICON_DIRECTIVES,
  ],
  templateUrl: './nodata-found.component.html',
  styleUrls: ['./nodata-found.component.scss']
})
export class NodataFoundComponent implements OnInit, OnChanges {
  @Input() title: Array<string>;
  @Input() screen: any;
  @Input() buttonName: string;
  @Input() isButtonDisabled: boolean = false;
  @Output() clickButton = new EventEmitter<boolean>();
  headerTitle: string = '';
  @Input() widgetDesc: string;
  @Input() buttonShow: boolean = true;
  constructor(private a_route: ActivatedRoute) { }
  userType: any = localStorage.getItem('userType');

  ngOnInit() {
    if (this.userType == 'JOB_SEEKER') {
      this.buttonShow = false;
    }

    // Only set headerTitle if widgetDesc is provided (ngOnChanges handles dynamic updates)
    if (this.widgetDesc) {
      this.headerTitle = this.widgetDesc;
    }
    this.a_route.queryParams.subscribe((res) => {
      if (res.master != "NETWORK" && res.master != "TEAM" && res.menu != null && res.menu != undefined) {
        this.headerTitle = res.menu;
      }
    })
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.isButtonDisabled && changes.isButtonDisabled.currentValue !== changes.isButtonDisabled.previousValue) {
        this.isButtonDisabled = this.isButtonDisabled;
    }
    if (changes.buttonShow) {
        this.buttonShow = changes.buttonShow.currentValue;
    }
    // Handle widgetDesc changes for NgComponentOutlet compatibility
    if (changes.widgetDesc && changes.widgetDesc.currentValue) {
      this.headerTitle = changes.widgetDesc.currentValue;
    }
}


  setBold(value: string): boolean {
    if (value[0] === 'b') {
      return true;
    }
    return false;
  }

  open() {
    // this.isButtonDisabled = true;
    this.clickButton.emit(true);
  }

  removeB(value: string): string {
    return value.substring(2, value.length);
  }

}
